<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <h4>Emails Going Out</h4>
        <p id="goingOutHeadline">{{ headline }}</p>
        <div v-if="data && data.allUsers && people.length > 1" class="p-field p-mb-3" style="max-width: 320px">
          <label for="goingOutSalesperson">Salesperson</label>
          <Dropdown id="goingOutSalesperson" v-model="salespersonId" :options="peopleOptions" optionLabel="name" optionValue="id" />
        </div>
        <DataTable :value="rows" :loading="loading" dataKey="followupId" class="p-datatable-sm" :rowHover="true"
          emptyMessage="No automatic emails are due in this period.">
          <Column header="Send" :styles="{ width: '5rem' }">
            <template #body="slot">
              <Checkbox :id="'send' + slot.data.followupId" :binary="true"
                :modelValue="!slot.data.skipped" :disabled="busyId === slot.data.followupId || !slot.data.canAct"
                @input="toggle(slot.data)" />
            </template>
          </Column>
          <Column field="dueAt" header="Due" />
          <Column header="Quote">
            <template #body="slot">
              <router-link :to="'/enquiries/' + slot.data.oppId + '/followup'">{{ slot.data.quoteRef }}</router-link>
            </template>
          </Column>
          <Column field="customerName" header="Customer" />
          <Column header="Contact">
            <template #body="slot">{{ slot.data.contactName }}<br /><small>{{ slot.data.contactEmail }}</small></template>
          </Column>
          <Column header="Email">
            <template #body="slot">Email {{ slot.data.stepNo }}: {{ slot.data.subject }}</template>
          </Column>
          <Column v-if="data && data.allUsers" field="salespersonName" header="Salesperson" />
          <Column header="Note">
            <template #body="slot">
              <span v-if="slot.data.skipped">Skipped by {{ slot.data.skipRequestedBy || 'a user' }}</span>
              <span v-else>{{ note(slot.data) }}</span>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import FollowupService, { errorMessage } from '@/service/FollowupService'
import { contactNote, bySalesperson, salespeople, headline } from './emailsGoingOut'

export default {
  // item (b), batch 3: each user sees their own; Admin (settings users) sees all and can filter by salesperson
  name: 'EmailsGoingOut',
  data: () => ({ followupService: new FollowupService(), data: null, loading: false, busyId: null, salespersonId: null }),
  computed: {
    headline() { return headline(this.data) },
    people() { return salespeople(this.data && this.data.rows) },
    peopleOptions() { return [{ id: null, name: 'Everyone' }].concat(this.people) },
    rows() { return bySalesperson(this.data && this.data.rows, this.salespersonId) }
  },
  created() {
    this.load()
  },
  methods: {
    note: contactNote,
    load() {
      this.loading = true
      return this.followupService.goingOut()
        .then(d => { this.data = d })
        .catch(err => {
          this.$toast.add({ severity: 'error', summary: 'Not loaded', detail: errorMessage(err, 'The emails going out could not be loaded.'), life: 5000 })
        })
        .finally(() => { this.loading = false })
    },
    /** Untick = skip this email (the quote's later ones still go); tick again = send it after all. */
    toggle(row) {
      this.busyId = row.followupId
      var call = row.skipped ? this.followupService.unskip(row.followupId) : this.followupService.skipNext(row.followupId, row.stepNo)
      return call
        .then(() => {
          row.skipped = !row.skipped
          if (row.skipped) row.skipRequestedBy = this.myName()
        })
        .catch(err => {
          this.$toast.add({ severity: 'error', summary: 'Not changed', detail: errorMessage(err, 'That email could not be changed.'), life: 5000 })
        })
        .finally(() => { this.busyId = null })
    },
    myName() {
      var p = this.$store && this.$store.getters && this.$store.getters['auth/getMyProfile']
      return p ? [p.firstName, p.lastName].filter(Boolean).join(' ') : 'you'
    }
  }
}
</script>
